import { CodeTypes } from './types/code'

export default {
  name: 'code',
  namespaced: true,
  state: {
    loading: false,
    banks: null
  },
  getters: {
    [CodeTypes.getters.GET_BANKS](state) {
      return state.banks
    }
  },
  mutations: {
    [CodeTypes.mutations.SET_LOADING](state, v) {
      state.loading = v
    },
    [CodeTypes.mutations.SET_BANKS](state, banks) {
      state.banks = banks
    }
  },
  actions: {
    async [CodeTypes.actions.GET_BANKS]({ commit, state }) {
      if (state.loading) {
        return null
      }

      if (!!state.banks && Array.isArray(state.banks) && state.banks.length > 0) {
        return state.banks
      }

      commit(CodeTypes.mutations.SET_LOADING, true)

      try {
        let response = await global.$fundaApi.query(gql`
          {
            data: getPaymentUserWithdrawAccountAllowBanks {
              code
              name
            }
          }
        `)

        // response 구조 확인: response.data 또는 response 자체가 배열
        let banks = response.data || response

        commit(CodeTypes.mutations.SET_BANKS, banks)
        return banks
      } catch (error) {
        console.error('은행 정보 조회 실패:', error)
        commit(CodeTypes.mutations.SET_BANKS, null)
        throw error
      } finally {
        commit(CodeTypes.mutations.SET_LOADING, false)
      }
    }
  }
}
